 <template>
    <div class="container">
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div>
            <el-button type="primary" @click="add()">添加广告</el-button>
            <div style="float: right">
                <div class="search">
                    <el-select v-model="queryParams.state" placeholder="选择状态">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="显示" :value="2"></el-option>
                    </el-select>
                    <div style="">
                        <el-input v-model="queryParams.keyword" placeholder="请输入关键字" clearable></el-input>
                    </div>
                    <div>
                        <el-button type="primary" @click="changeQuery()">搜索</el-button>
                    </div>
                </div>
            </div>
        </div>

        <el-table :data="tableData" tooltip-effect="dark" style="width: 100%; margin-top: 10px">
            <el-table-column width="55" type="selection"></el-table-column>
            <el-table-column label="ID" width="120">
                <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column>
            <el-table-column prop="title" label="标题" width="280"></el-table-column>
            <el-table-column prop="image" label="图片" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-image style="width: 100px; height: 100px" :src="scope.row.image" fit="fill"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="排序" width="120">
                <template slot-scope="scope">{{ scope.row.r }}</template>
            </el-table-column>
            <el-table-column prop="user_type" label="用户类型" width="120">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.user_type === 'new'">新用户</el-tag>
                    <el-tag v-else-if="scope.row.user_type === 'all'">所有用户</el-tag>
                    <el-tag v-else-if="scope.row.user_type === 'invited'">邀请用户</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="赠送礼品" width="120">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.biz_type === 'coupon'">优惠券</el-tag>
                    <el-tag v-else-if="scope.row.biz_type === 'balance_recharge'">余额充值</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="开始时间" width="150">
                <template slot-scope="scope">{{ formatTimestampToDate(scope.row.ctime) }}</template>
            </el-table-column>
            <el-table-column label="结束时间" width="150">
                <template slot-scope="scope">{{ formatTimestampToDate(scope.row.etime) }}</template>
            </el-table-column>
            <el-table-column prop="state_str" label="状态" width="120">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.state === 2" type="success">显示</el-tag>
                    <el-tag v-else>隐藏</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="text" @click="editPopupWithData(scope.row)">编辑</el-button>
                    <el-button type="text" @click="deletePopup(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="添加活动" :visible.sync="addVisible" width="50%">
            <el-form
                ref="form"
                v-bind:rules="rules"
                v-bind:model="form"
                label-position="right"
                label-suffix=":"
                label-width="100px"
                size="large"
            >
                <el-form-item label="排序" prop="r">
                    <el-input v-model="form.r" placeholder="数字越大排名越靠前"></el-input>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input v-model="form.title" placeholder="请输入广告名称"></el-input>
                </el-form-item>
                <el-form-item label="上传图片" prop="image">
                    <el-button @click.prevent="choiceImg">选择图片</el-button>
                    <img v-if="form.image" :src="form.image" width="100px" height="100px" class="avatar" />
                </el-form-item>
                <!--                <el-form-item label="描述" prop="desc">
                    <el-input v-model="form.desc" placeholder="请输入广告描述"></el-input>
                </el-form-item>-->
                <el-form-item label="开始时间" prop="ctime">
                    <el-date-picker v-model="form.ctime" type="datetime" placeholder="选择开始时间"> </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="etime">
                    <el-date-picker v-model="form.etime" type="datetime" placeholder="选择结束时间"> </el-date-picker>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-radio-group v-model.number="form.state">
                        <el-radio :label="1">隐藏</el-radio>
                        <el-radio :label="2">显示</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="用户类型" prop="user_type">
                    <el-radio-group v-model="form.user_type">
                        <el-radio label="new">新用户</el-radio>
                        <el-radio label="all">所有用户</el-radio>
                        <el-radio label="invited">邀请用户</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="业务类型" prop="biz_type">
                    <el-radio-group v-model="form.biz_type" @change="handleBizTypeChange">
                        <el-radio label="coupon">优惠券</el-radio>
                        <el-radio label="balance_recharge">余额充值</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="关联优惠券" v-if="form.biz_type === 'coupon'">
                    <el-button @click="openCouponDialog">选择优惠券</el-button>
                    <div v-if="selectedCoupons.length > 0" class="selected-coupons">
                        <el-tag v-for="coupon in selectedCoupons" :key="coupon.id" closable @close="removeCoupon(coupon.id)">
                            {{ coupon.name }}
                        </el-tag>
                    </div>
                </el-form-item>
                <el-form-item label="充值金额" v-if="form.biz_type === 'balance_recharge'">
                    <el-input v-model="form.balance_amount" type="number" placeholder="请输入充值金额">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">发布</el-button>
                    <el-button @click="addVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 选择图片对话框 -->
        <div class="img">
            <Picture :ImgVisible="ImgVisible" @toggleImg="toggleImg" @getImg="getImg"></Picture>
        </div>

        <!-- 优惠券选择对话框 -->
        <el-dialog title="选择优惠券" :visible.sync="couponDialogVisible" width="80%" @close="closeCouponDialog">
            <div class="coupon-search-container">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="优惠券名称:">
                        <el-input placeholder="请输入优惠券名称" v-model="couponQueryParams.name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-select v-model="couponQueryParams.state" placeholder="请选择状态" clearable>
                            <el-option label="上线" :value="2"></el-option>
                            <el-option label="下线" :value="1"></el-option>
                            <el-option label="已下架" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="loadCouponList()">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <el-table
                ref="couponTable"
                :data="couponList"
                v-loading="couponLoading"
                @selection-change="handleCouponSelection"
                element-loading-text="数据加载中"
                stripe
                border
                style="margin-top: 20px"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
                <el-table-column prop="name" label="优惠券名称" width="200" align="center"></el-table-column>
                <el-table-column prop="price" label="优惠劵价格" width="100" align="center"></el-table-column>
                <el-table-column prop="full_price" label="满足金额" width="100" align="center"></el-table-column>
                <el-table-column prop="ctime" label="开始时间" width="160" align="center">
                    <template slot-scope="scope">{{ formatTimestampToDate(scope.row.ctime) }}</template>
                </el-table-column>
                <el-table-column prop="etime" label="结束时间" width="160" align="center">
                    <template slot-scope="scope">{{ formatTimestampToDate(scope.row.etime) }}</template>
                </el-table-column>
                <el-table-column prop="is_receive" label="是否可领取" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.is_receive">可领取</el-tag>
                        <el-tag type="danger" v-if="!scope.row.is_receive">不可领取</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="stock" label="库存" width="80" align="center"></el-table-column>
                <el-table-column label="状态" prop="state" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.state === 1">下线</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 2">上线</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 3">已下架</el-tag>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container" style="margin-top: 20px; text-align: center">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="couponPageInfo.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="couponPageInfo.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="couponPageInfo.total"
                >
                </el-pagination>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeCouponDialog">取消</el-button>
                <el-button type="primary" @click="addSelectedCoupons">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import { request } from '@/common/request';
import Picture from '@/components/Picture.vue';

export default {
    name: 'poppup',
    components: {
        Picture,
        Breadcrumb
    },
    data() {
        return {
            loading: false,
            couponLoading: false,
            queryParams: {
                state: null,
                keyword: '',
                page: 1,
                pagesize: 10
            },
            options: {
                biz_type_map: {
                    balance_recharge: '余额充值',
                    coupon: '优惠券'
                },
                user_type_map: {
                    all: '所有用户',
                    new: '新用户'
                }
            },
            tableData: [
                {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }
            ],
            rules: {
                title: [{ required: true, message: '请输入广告标题', trigger: 'blur' }],
                image: [{ required: true, message: '请上传广告图片', trigger: 'change' }],
                desc: [{ required: true, message: '请输入广告描述', trigger: 'blur' }],
                ctime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                etime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
                r: [
                    { required: true, message: '请输入排序值', trigger: 'blur' },
                    { pattern: /^\d+$/, message: '排序值必须为数字', trigger: 'blur' }
                ],
                user_type: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
                biz_type: [{ required: true, message: '请选择业务类型', trigger: 'change' }],
                biz_params: [{ required: true, message: '请输入业务参数', trigger: 'blur' }],
                state: [{ required: true, message: '请选择状态', trigger: 'change' }]
            },
            ImgVisible: false,
            addVisible: false,
            form: {
                title: '',
                image: '',
                desc: '',
                ctime: '',
                etime: '',
                r: 0,
                user_type: 'new',
                biz_type: 'coupon',
                biz_params: '',
                biz_params_obj: {
                    id: 0,
                    ids: [],
                    option_type: '',
                    biz_content: null
                },
                state: 1
            },
            checked: false,
            radio: '1',
            menuList: ['店铺', '活动弹窗'],
            couponDialogVisible: false,
            selectedCoupons: [],
            couponList: [],
            couponPageInfo: {
                list: [],
                page: 1,
                pagesize: 10,
                total: 0
            },
            couponQueryParams: {
                name: '',
                state: '',
                page: 1,
                pagesize: 10
            }
        };
    },
    created() {
        this.getPopupList();
        this.getPopupOptions();
    },
    methods: {
        getPopupList() {
            // 门店列表
            this.loading = true;
            request.get('/common/popup/list', { page: 1, pageNum: 99999 }).then((ret) => {
                if (ret.code === 1) {
                    this.tableData = ret.data.list;
                }
            });
        },
        getPopupOptions() {
            // 获取门店列表
            request.get('/common/popup/options').then((ret) => {
                if (ret.code === 1) {
                    this.options = ret.data;
                }
            });
        },

        changeQuery() {
            // 根据状态和关键字查询弹窗活动
            const params = {
                page: 1,
                pageNum: this.queryParams.pagesize, // 获取所有相关数据
                state: this.queryParams.state
            };

            // 如果有关键字，添加到查询参数中
            if (this.queryParams.keyword) {
                params.key = this.queryParams.keyword;
            }

            this.loading = true;
            request
                .get('/common/popup/list', params)
                .then((ret) => {
                    if (ret.code === 1) {
                        this.tableData = ret.data.list;
                    } else {
                        this.$message.error(ret.msg || '查询失败');
                    }
                })
                .catch((error) => {
                    console.error('查询弹窗活动失败:', error);
                    this.$message.error('查询失败，请稍后重试');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        add() {
            this.mode = 'add';
            this.addVisible = true;
            // 重置表单
            this.form = {
                title: '',
                image: '',
                desc: '',
                ctime: '',
                etime: '',
                r: 0,
                user_type: 'new',
                biz_type: 'coupon',
                biz_params: '',
                state: 1
            };
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },

        editPopup(row) {
            this.mode = 'edit';
            this.addVisible = true;
            // 设置表单数据 - 这里应该从表格获取实际的行数据
            // 注意：在实际实现中，可能需要获取行索引或传递实际数据
            this.$message.warning('编辑功能需要传递具体行数据，当前仅作示例');
        },

        // 根据表格行点击事件传递实际数据的编辑方法
        editPopupWithData(row) {
            this.mode = 'edit';
            this.addVisible = true;
            // 设置表单数据
            this.form = { ...row };
            // 初始化 biz_params_obj，默认为空对象
            if (!this.form.biz_params_obj) {
                this.form.biz_params_obj = {
                    id: 0,
                    ids: [],
                    option_type: '',
                    biz_content: null
                };
            }

            // 处理不同业务类型的数据
            if (this.form.biz_type === 'coupon') {
                // 如果 biz_params 是逗号分隔的字符串（旧格式），则解析并更新 biz_params_obj
                if (this.form.biz_params && !this.form.biz_params.startsWith('{')) {
                    const ids = this.form.biz_params
                        .split(',')
                        .map(Number)
                        .filter((id) => id);
                    this.form.biz_params_obj = {
                        id: 0,
                        ids: ids,
                        option_type: '',
                        biz_content: null
                    };
                    this.selectedCoupons = [];

                    // 如果有优惠券ID，尝试加载优惠券详情用于显示
                    if (ids.length > 0) {
                        // 加载选中的优惠券信息以显示在界面上
                        this.loadSelectedCouponDetails(ids);
                    }
                } else if (this.form.biz_params && this.form.biz_params.startsWith('{')) {
                    // 如果 biz_params 是 JSON 字符串，则解析为对象
                    try {
                        this.form.biz_params_obj = JSON.parse(this.form.biz_params);
                        // 加载选中的优惠券信息以显示在界面上
                        if (this.form.biz_params_obj.ids && this.form.biz_params_obj.ids.length > 0) {
                            this.loadSelectedCouponDetails(this.form.biz_params_obj.ids);
                        }
                    } catch (error) {
                        console.error('解析 biz_params JSON 失败:', error);
                        this.form.biz_params_obj = {
                            id: 0,
                            ids: [],
                            option_type: '',
                            biz_content: null
                        };
                    }
                } else if (this.form.biz_params_obj && this.form.biz_params_obj.ids) {
                    // 直接使用 biz_params_obj 中的 ids 数组
                    if (this.form.biz_params_obj.ids && this.form.biz_params_obj.ids.length > 0) {
                        this.loadSelectedCouponDetails(this.form.biz_params_obj.ids);
                    }
                }
            } else if (this.form.biz_type === 'balance_recharge') {
                // 处理余额充值类型
                try {
                    if (this.form.biz_params && this.form.biz_params.startsWith('{')) {
                        // 解析 JSON 字符串
                        this.form.biz_params_obj = JSON.parse(this.form.biz_params);

                        // 从 biz_content 提取金额
                        if (this.form.biz_params_obj.biz_content) {
                            this.form.balance_amount = parseFloat(this.form.biz_params_obj.biz_content);
                        }
                    } else {
                        // 如果不是 JSON 格式，尝试解析为简单数值
                        this.form.balance_amount = parseFloat(this.form.biz_params);

                        // 设置 biz_params_obj
                        this.form.biz_params_obj = {
                            id: 0,
                            ids: [],
                            option_type: '',
                            biz_content: this.form.balance_amount
                        };
                    }
                } catch (error) {
                    console.error('解析余额充值参数失败:', error);
                    this.form.balance_amount = 0;
                    this.form.biz_params_obj = {
                        id: 0,
                        ids: [],
                        option_type: '',
                        biz_content: 0
                    };
                }
            }
            // 如果时间戳是数字，转换为日期格式
            if (typeof this.form.ctime === 'number') {
                this.form.ctime = this.formatTimestampToDate(this.form.ctime);
            }
            if (typeof this.form.etime === 'number') {
                this.form.etime = this.formatTimestampToDate(this.form.etime);
            }
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },

        // 删除
        deletePopup(id) {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    request.get('/common/popup/delete', { id }).then((ret) => {
                        if (ret.code == 1) {
                            this.$message.success('操作成功');
                            this.getPopupList();
                        } else {
                            this.$message.error(ret.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        choiceImg() {
            this.ImgVisible = true;
        },
        getImg(url) {
            // 获取选择的img
            this.$set(this.form, 'image', url);
        },
        toggleImg(val) {
            // 关闭 img对话框
            this.ImgVisible = val;
        },
        formatTimestampToDate(timestamp) {
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        // 加载选中的优惠券详细信息
        loadSelectedCouponDetails(couponIds) {
            // 根据提供的优惠券ID列表，从服务器获取这些优惠券的详细信息
            const params = {
                page: 1,
                pageNum: 99999, // 获取所有相关优惠券
                ids: couponIds.join(',') // 假设后端支持通过ids参数查询特定ID的优惠券
            };

            request
                .get('/coupon/list', params)
                .then((ret) => {
                    if (ret.code === 1) {
                        // 筛选出与传入ID匹配的优惠券
                        const matchedCoupons = ret.data.list.filter((coupon) => couponIds.includes(coupon.id));

                        // 更新已选优惠券列表
                        this.selectedCoupons = matchedCoupons.map((coupon) => ({
                            id: coupon.id,
                            name: coupon.name
                        }));

                        // 更新表单中的 biz_params_obj.ids
                        this.form.biz_params_obj = {
                            id: 0,
                            ids: this.selectedCoupons.map((coupon) => coupon.id),
                            option_type: '',
                            biz_content: null
                        };

                        // 更新 biz_params 为 JSON 字符串
                        this.form.biz_params = JSON.stringify(this.form.biz_params_obj);
                    } else {
                        console.error('加载选中优惠券详情失败:', ret.msg);
                        // 如果无法获取详细信息，至少创建基本的优惠券对象
                        this.selectedCoupons = couponIds.map((id) => ({
                            id: id,
                            name: `优惠券${id}` // 使用默认名称
                        }));

                        // 更新表单中的 biz_params_obj.ids
                        this.form.biz_params_obj = {
                            id: 0,
                            ids: couponIds,
                            option_type: '',
                            biz_content: null
                        };

                        // 更新 biz_params 为 JSON 字符串
                        this.form.biz_params = JSON.stringify(this.form.biz_params_obj);
                    }
                })
                .catch((error) => {
                    console.error('请求选中优惠券详情时出错:', error);
                    // 出错时使用默认名称
                    this.selectedCoupons = couponIds.map((id) => ({
                        id: id,
                        name: `优惠券${id}`
                    }));

                    // 更新表单中的 biz_params_obj.ids
                    this.form.biz_params_obj = {
                        id: 0,
                        ids: couponIds,
                        option_type: '',
                        biz_content: null
                    };

                    // 更新 biz_params 为 JSON 字符串
                    this.form.biz_params = JSON.stringify(this.form.biz_params_obj);
                });
        },
        openCouponDialog() {
            this.couponDialogVisible = true;
            this.loadCouponList();
        },
        loadCouponList() {
            this.couponLoading = true;
            request.get('/coupon/list', this.couponQueryParams).then((ret) => {
                if (ret.code === 1) {
                    this.couponPageInfo = ret.data;
                    this.couponList = ret.data.list.map((item) => {
                        // 检查是否已在选中列表中
                        const isSelected = this.selectedCoupons.some((coupon) => coupon.id === item.id);
                        return { ...item, isSelected };
                    });
                } else {
                    this.$message.error(ret.msg);
                }
                this.couponLoading = false;
            });
        },
        handleCouponSelection(selection) {
            // 更新选中状态
            this.couponList.forEach((item) => {
                const isSelected = selection.some((selected) => selected.id === item.id);
                item.isSelected = isSelected;
            });
        },
        addSelectedCoupons() {
            const selectedRows = this.$refs.couponTable.selection || [];
            selectedRows.forEach((row) => {
                // 检查是否已存在
                if (!this.selectedCoupons.some((coupon) => coupon.id === row.id)) {
                    this.selectedCoupons.push({
                        id: row.id,
                        name: row.name
                    });
                }
            });

            // 构建 biz_params_obj 对象
            this.form.biz_params_obj = {
                id: 0,
                ids: this.selectedCoupons.map((coupon) => coupon.id),
                option_type: '',
                biz_content: null
            };

            // 将 biz_params_obj 转换为 JSON 字符串并赋值给 biz_params
            this.form.biz_params = JSON.stringify(this.form.biz_params_obj);

            this.couponDialogVisible = false;
        },
        removeCoupon(id) {
            this.selectedCoupons = this.selectedCoupons.filter((coupon) => coupon.id !== id);

            // 重新构建 biz_params_obj 对象
            this.form.biz_params_obj = {
                id: 0,
                ids: this.selectedCoupons.map((coupon) => coupon.id),
                option_type: '',
                biz_content: null
            };

            // 将 biz_params_obj 转换为 JSON 字符串并赋值给 biz_params
            this.form.biz_params = JSON.stringify(this.form.biz_params_obj);
        },
        closeCouponDialog() {
            this.couponDialogVisible = false;
        },
        handleSizeChange(val) {
            this.couponQueryParams.pagesize = val;
            this.couponQueryParams.page = 1;
            this.loadCouponList();
        },
        handleCurrentChange(val) {
            this.couponQueryParams.page = val;
            this.loadCouponList();
        },
        handleBizTypeChange(value) {
            // 业务类型改变时的处理逻辑
            // 清空之前业务类型相关的数据
            if (value === 'coupon') {
                // 切换到优惠券类型时，清空余额充值相关字段
                delete this.form.balance_amount;
            } else if (value === 'balance_recharge') {
                // 切换到余额充值类型时，清空优惠券相关数据
                this.selectedCoupons = [];
                this.form.biz_params_obj = {
                    id: 0,
                    ids: [],
                    option_type: '',
                    biz_content: null
                };
            }
        },
        onSubmit() {
            this.loading = true;
            let url = '/common/popup/add';
            if (this.mode === 'edit') {
                url = '/common/popup/edit';
            }

            // 根据不同的业务类型进行校验
            if (this.form.biz_type === 'coupon') {
                // 当 biz_type 为 coupon 时，校验是否选择了优惠券
                if (!this.form.biz_params_obj || !this.form.biz_params_obj.ids || this.form.biz_params_obj.ids.length === 0) {
                    this.$message.error('请选择优惠券！');
                    this.loading = false;
                    return; // 中断提交
                }
            } else if (this.form.biz_type === 'balance_recharge') {
                // 当 biz_type 为 balance_recharge 时，校验充值金额
                if (!this.form.balance_amount || this.form.balance_amount <= 0) {
                    this.$message.error('请输入有效的充值金额！');
                    this.loading = false;
                    return; // 中断提交
                }
            }

            // 处理时间字段，转换为时间戳
            const submitForm = { ...this.form };
            if (submitForm.ctime && typeof submitForm.ctime !== 'number') {
                submitForm.ctime = Math.floor(new Date(submitForm.ctime).getTime() / 1000);
            }
            if (submitForm.etime && typeof submitForm.etime !== 'number') {
                submitForm.etime = Math.floor(new Date(submitForm.etime).getTime() / 1000);
            }

            // 根据业务类型处理参数
            if (submitForm.biz_type === 'coupon' && this.selectedCoupons.length > 0) {
                // 处理优惠券类型
                submitForm.biz_params_obj = {
                    id: 0,
                    ids: this.selectedCoupons.map((coupon) => coupon.id),
                    option_type: '',
                    biz_content: null
                };
                submitForm.biz_params = JSON.stringify(submitForm.biz_params_obj);
            } else if (submitForm.biz_type === 'balance_recharge') {
                // 处理余额充值类型
                submitForm.biz_params_obj = {
                    id: 0,
                    ids: [],
                    option_type: '',
                    biz_content: parseFloat(submitForm.balance_amount) // 将金额存储到 biz_content
                };
                submitForm.biz_params = JSON.stringify(submitForm.biz_params_obj);
            }

            request.postJson(url, submitForm).then((ret) => {
                if (ret.code === 1) {
                    this.$message.success('保存成功！');
                    this.addVisible = false;
                    this.getPopupList();
                } else {
                    this.$message.error(ret.msg);
                }
                this.loading = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.itemSet {
    margin-top: 20px;
    font-size: 14px;
}

.selected-coupons {
    margin-top: 10px;
}

.selected-coupons .el-tag {
    margin-right: 5px;
    margin-bottom: 5px;
}
.search {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>